import { THEME_CONFIGS } from "../types/brand";
import { DEFAULT_BRAND } from "../theme/brandTheme";

// Theme-specific layout helper functions
export const getThemeLayout = (theme: string) => {
  switch (theme) {
    case "TYPE_1": // Modern Minimal
      return {
        container: "max-w-7xl mx-auto lg:px-6 md:px-2 px-4 space-y-4",
        profileSection: "relative pt-2 ",
        profileImage: "absolute left-1/2 -translate-x-1/2 -top-16",
        profileImageSize: "w-32 h-32",
        profileInfo: "text-center pt-20",
        contentGrid: "grid grid-cols-1 lg:grid-cols-3 lg:col-span-3 gap-12",
        statsGrid: "grid grid-cols-4  lg:gap-6 md:gap-4 gap-2",
        joinCard: "2xl:sticky lg:top-4 lg:col-span-1 mt-12",
        description: "mt-12",
        showcase: "mt-12",
        bannerHeight: "h-64",
        bannerImage: "absolute z-10 inset-0 w-full h-full object-cover opacity-90",
        bannerOverlay:
          "absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-white/80",
        profilePosition: "relative z-10",
        statsPosition: "lg:col-span-2",
        descriptionPosition: "lg:col-span-2 mt-12",
        showcasePosition: "lg:col-span-2 mt-12",
      };

    case "TYPE_2": // Bold & Vibrant
      return {
        container: "max-w-7xl mx-auto lg:px-4 md:px-2 px-3",
        profileSection: "relative pt-16",
        profileImage: "absolute lg:right-8  md:right-4 right-[40%] -top-12 z-20",
        profileImageSize: "lg:w-28 lg:h-28 md:w-24 md:h-24 w-20 h-20",
        profileInfo: "lg:ml-8 md:ml-4 ml-1 max-w-md",
        contentGrid: "grid grid-cols-1 xl:grid-cols-12 xl:col-span-12 gap-8",
        statsGrid: "grid grid-cols-4 lg:gap-6 md:gap-4 gap-2",
        joinCard:
          "xl:col-span-3 xl:col-start-1 xl:row-start-1 xl:sticky xl:top-4 mt-12",
        description: "xl:col-span-9 xl:col-start-4 mt-8",
        showcase: "xl:col-span-9 xl:col-start-4 mt-8",
        bannerHeight: "h-64",
        bannerImage: "absolute z-10 inset-0 w-full !h-64 object-cover opacity-70",
        bannerOverlay:
          "absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/20",
        profilePosition: "relative z-10",
        statsPosition: "xl:col-span-9 xl:col-start-4",
        descriptionPosition: "xl:col-span-9 xl:col-start-4 mt-8",
        showcasePosition: "xl:col-span-9  xl:col-start-4 mt-8",
      };

    case "TYPE_3": // Elegant Professional
      return {
        container: "top-36 left-[25%] w-full  max-w-7xl mx-auto lg:px-8 md:px-2 px-2 space-y-8",
        profileSection: "relative pt-16 text-center",
        profileImage: "absolute left-1/2 -translate-x-1/2 -top-20 z-20",
        profileImageSize: "w-36 h-36",
        profileInfo: "pt-2",
        contentGrid: "grid grid-cols-1 xl:grid-cols-6 lg:col-span-4 gap-4",
        statsGrid: "grid grid-cols-4 lg:gap-6 md:gap-4 w-full gap-2 ",
        joinCard: " xl:col-span-2 xl:col-start-1 xl:row-start-1 h-min mt-12",
        description: " xl:col-span-4 xl:col-start-3",
        showcase: "mt-16 xl:col-span-4",
        bannerHeight: "h-64",
        bannerImage: "absolute z-10 inset-0 w-full h-full object-cover opacity-60",
        bannerOverlay:
          "absolute -z-10 inset-0 bg-gradient-to-b from-black/30 via-transparent to-white/90",
        profilePosition: "relative z-10",
        statsPosition: "w-full",
        descriptionPosition: "w-full",
        showcasePosition: "w-full mt-16",
      };

    case "TYPE_4": // Creative Playful
      return {
        container: "max-w-7xl mx-auto px-4",
        profileSection: "relative pt-20 pb-8",
        profileImage: "absolute lg:left-8 left-1/2 -translate-x-1/2 lg:translate-x-0 -top-16 z-20",
        profileImageSize: "w-32 h-32",
        profileInfo: "xl:ml-44 ml-4 md:ml-24",
        contentGrid:
          "grid grid-cols-1 xl:grid-cols-3 xl:col-span-3 gap-8",
        statsGrid: "grid grid-cols-4 lg:gap-6 md:gap-4 gap-2 ",
        joinCard: "xl:col-span-1 xl:sticky xl:top-4",
        description: "xl:col-span-2 mt-8",
        showcase: "xl:col-span-2 mt-8",
        bannerHeight: "h-64",
        bannerImage: "absolute z-10 inset-0 w-full h-full object-cover opacity-80",
        bannerOverlay:
          "absolute inset-0 bg-gradient-to-br from-black/25 via-transparent to-black/15",
        profilePosition: "relative z-10",
        statsPosition: "xl:col-span-2",
        descriptionPosition: "xl:col-span-2 mt-8",
        showcasePosition: "xl:col-span-2 mt-8",
      };

    default:
      return {
        container: "max-w-6xl mx-auto px-6 space-y-8",
        profileSection: "relative pt-20 pb-8",
        profileImage: "absolute left-1/2 -translate-x-1/2 -top-16",
        profileImageSize: "w-32 h-32",
        profileInfo: "text-center pt-32",
        contentGrid: "grid grid-cols-1 lg:grid-cols-2 lg:col-span-2 gap-12",
        statsGrid: "grid grid-cols-4 lg:gap-6 md:gap-4 gap-2 mt-12",
        joinCard: "lg:sticky lg:top-4 lg:ml-8 mt-12",
        description: "mt-12",
        showcase: "mt-12",
        bannerHeight: "h-64",
        bannerImage: "absolute inset-0 w-full h-full object-cover opacity-90",
        bannerOverlay:
          "absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-white/80",
        profilePosition: "relative z-10",
        statsPosition: "lg:col-span-1",
        descriptionPosition: "lg:col-span-1 mt-12",
        showcasePosition: "lg:col-span-1 mt-12",
      };
  }
};

// Theme-specific styling helper functions.
// Colors come from the brand-* Tailwind tokens (runtime CSS variables), not
// from string interpolation — interpolated arbitrary values like
// `from-[${color}]` are invisible to Tailwind's static scan and never
// generated any CSS. The `colors` param is kept for call compatibility.
export const getThemeStyles = (
  theme: string,
  _colors: { primary: string; secondary: string }
) => {
  switch (theme) {
    case "TYPE_1": // Modern Minimal
      return {
        banner: "h-48 bg-gradient-to-b from-brand-secondary to-card",
        profileCard:
          "lg:p-8 p-2 sm:p-4 md:p-6",
        statsCard:
          " px-2 md:px-4 lg:px-6 text-center",
        joinCard: "lg:p-8 p-4 sm:p-4 md:p-6",
        nicheTag: "px-4 py-1 rounded-full text-sm font-xs",
        socialIcon: "text-muted-foreground hover:text-muted-foreground transition-colors",
        statsContainer:
          "lg:p-8 p-2 sm:p-4 md:p-6 ",
        descriptionContainer:
          "lg:p-8 p-2 sm:p-4 md:p-6",
        showcaseContainer:
          "lg:p-8 p-4 sm:p-4 md:p-6 mt-8",
      };

    case "TYPE_2": // Bold & Vibrant
      return {
        banner: "h-32 bg-gradient-to-r from-brand-600 via-brand-secondary to-brand-600",
        profileCard: ` lg:p-8 p-2 sm:p-4 md:p-6`,
        statsCard: `px-2 md:px-4 lg:px-6 text-center text-brand-600`,
        joinCard: `bg-gradient-to-br from-brand-secondary to-card rounded-xl shadow-xl lg:p-8  p-4 md:p-6`,
        nicheTag: "px-4 py-1 rounded-full text-xs font-semibold shadow-lg",
        socialIcon:
          "text-muted-foreground hover:text-foreground transition-all duration-300 transform hover:scale-110",
        statsContainer: `lg:p-8 p-2 sm:p-4 md:p-6 mt-8`,
        descriptionContainer: `lg:p-8 p-2 sm:p-4 md:p-6 mt-8`,
        showcaseContainer: `bg-gradient-to-br from-brand-secondary to-card rounded-xl shadow-xl lg:p-8 p-4 sm:p-4 md:p-6 mt-8`,
      };

    case "TYPE_3": // Elegant Professional
      return {
        banner: "h-48 bg-gradient-to-b from-brand-secondary to-card",
        profileCard:
          "bg-card rounded-lg shadow-md border border-border lg:p-10 p-2 sm:p-4 md:p-6",
        statsCard:
          "px-2 md:px-4 lg:px-6 text-center",
        joinCard: "bg-card p-4 md:p-6 mt-8 rounded-lg shadow-md border border-border",
        nicheTag: "px-3 py-1 rounded-md text-xs font-semibold border",
        socialIcon: "text-muted-foreground hover:text-muted-foreground transition-colors",
        statsContainer:
          "",
        descriptionContainer:
          " lg:p-8 p-4 sm:p-4 md:p-6 mt-8",
        showcaseContainer:
          "bg-card rounded-lg shadow-md border border-border lg:p-8 p-2 sm:p-4 md:p-6 mt-8",
      };

    case "TYPE_4": // Creative Playful
      return {
        banner: "h-36 bg-gradient-to-br from-brand-600 via-brand-secondary to-brand-600",
        profileCard: ` lg:p-8 p-2 sm:p-4 md:p-6 hover:-rotate-1 transition-all duration-300`,
        statsCard: `px-2 md:px-4 lg:px-6 text-center hover:scale-105 transition-all duration-300`,
        joinCard: ` bg-gradient-to-br from-brand-secondary to-card rounded-[2rem] shadow-2xl lg:p-8 p-4 md:p-6 hover:rotate-1 transition-all duration-300`,
        nicheTag:
          "px-4 py-1 rounded-full text-xs font-bold shadow-md hover:shadow-lg transition-all duration-300",
        socialIcon:
          "text-muted-foreground hover:text-foreground transition-all duration-300 transform hover:scale-125 hover:rotate-12",
        statsContainer: `lg:p-8 p-2 sm:p-4 md:p-6 hover:-rotate-1 transition-all duration-300`,
        descriptionContainer: `lg:p-8 p-2 sm:p-4 md:p-6 mt-8 hover:rotate-1 transition-all duration-300`,
        showcaseContainer: `bg-gradient-to-br from-brand-secondary to-card rounded-[2rem] shadow-2xl lg:p-8 p-4 md:p-6 mt-8 hover:-rotate-1 transition-all duration-300`,
      };

    default:
      return {
        banner: "h-48 bg-gradient-to-b from-brand-secondary to-card",
        profileCard:
          "bg-card rounded-2xl shadow-sm border border-border lg:p-8 p-2 sm:p-4 md:p-6",
        statsCard:
          "bg-card rounded-xl shadow-sm border border-border p-6 px-2 md:px-4 lg:px-6 text-center",
        joinCard: "bg-card rounded-2xl shadow-sm border border-border lg:p-8 p-2 sm:p-4 md:p-6",
        nicheTag: "px-4 py-1 rounded-full text-xs font-semibold",
        socialIcon: "text-muted-foreground hover:text-muted-foreground transition-colors",
        statsContainer:
          "bg-card rounded-2xl shadow-sm border border-border lg:p-8 p-2 sm:p-4 md:p-6 mt-8",
        descriptionContainer:
          "bg-card rounded-2xl shadow-sm border border-border lg:p-8 p-2 sm:p-4 md:p-6 mt-8",
        showcaseContainer:
          "bg-card rounded-2xl shadow-sm border border-border lg:p-8 p-2 sm:p-4 md:p-6 mt-8",
      };
  }
};

// Function to process content and convert YouTube links to iframes
export function processYouTubeContent(content: string): string {
  if (!content) return content;

  // First, handle YouTube links that are wrapped in <a> tags by TipTap
  let processedContent = content.replace(
    /<a[^>]*href="(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+))"[^>]*>.*?<\/a>/g,
    (_, _url, videoId) => {
      const embedUrl = `https://www.youtube.com/embed/${videoId}`;
      return `<div class="youtube-embed-wrapper"><iframe width="100%" height="315" src="${embedUrl}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>`;
    }
  );

  // Then handle any plain YouTube URLs that might not be in links
  processedContent = processedContent.replace(
    /(?<!href=["'])https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)(?!["'])/g,
    (_, videoId) => {
      const embedUrl = `https://www.youtube.com/embed/${videoId}`;
      return `<div class="youtube-embed-wrapper"><iframe width="100%" height="315" src="${embedUrl}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>`;
    }
  );

  // Also wrap existing iframes in our wrapper for consistent styling
  processedContent = processedContent.replace(
    /<iframe([^>]*youtube[^>]*)><\/iframe>/g,
    '<div class="youtube-embed-wrapper"><iframe$1></iframe></div>'
  );

  return processedContent;
}

// Get CSS classes based on appearance settings
export const getAppearanceClasses = (appearanceSettings: any) => {
  if (!appearanceSettings) {
    return THEME_CONFIGS["TYPE_1"];
  }
  if (appearanceSettings.theme) {
    return THEME_CONFIGS[
      appearanceSettings.theme as keyof typeof THEME_CONFIGS
    ];
  } else {
    return THEME_CONFIGS["TYPE_1"];
  }
};

// Get color values from appearance settings
export const getColors = (appearanceSettings: any) => {
  return {
    primary: appearanceSettings?.primayColour || DEFAULT_BRAND.primary,
    secondary: appearanceSettings?.secondaryColour || DEFAULT_BRAND.secondary,
  };
};
